const $ = jQuery.noConflict();

'use strict';

const accordion = {
	$accordionTitle: null,
	$accordionOptions: null,

	init: function() {
		this.initValues();
		this.bindEvents();
	},

	initValues: function() {
		accordion.$accordionTitle = $('.js-accordion-item');
		accordion.$accordionOptions = $('.js-accordion-content');
	},

	bindEvents: function() {
		// Open Accordion
		accordion.$accordionTitle.on('click', accordion.openAccordion);

		// if (accordion.$accordionTitle.length > 0) {
		// 	$('body').on('mouseup', function(e) {
		// 		if (!accordion.$accordionTitle.is(e.target) && !accordion.$accordionOptions.is(e.target) && accordion.$accordionTitle.has(e.target).length === 0 && accordion.$accordionOptions.has(e.target).length === 0) {
		// 			accordion.closeAccordion();
		// 		}
		// 	});
		// }
	},

	// Open Accordion
	openAccordion: function(e) {
		// Return if e.target is inside the active accordion
		if (accordion.$accordionOptions.is(e.target) || accordion.$accordionOptions.has(e.target).length) {
			return;
		}
		// Close accordion that are active
		if (!$(this).hasClass('active')) {
			accordion.closeAccordion();
		}
		// Add active class to open accordion
		$(this).toggleClass('active').find(accordion.$accordionOptions).slideToggle(300, function() {
			if ($(this).is(':visible')) {
				$(this).css('display', 'flex');
			}
		});
	},

	// Close Accordion
	closeAccordion: function() {
		accordion.$accordionTitle.removeClass('active');
		accordion.$accordionOptions.slideUp(300);
	},
};

export default accordion;
